module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "ibox"
  }, [_c('div', {
    staticClass: "ibox-content ibox-content-padding-xs"
  }, [_c('h2', {
    staticClass: "truncate"
  }, [_vm._v("Public Job Settings")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Minimum Quantity Cutoff")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.publicJobCutoff),
      expression: "publicJobCutoff"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.publicJobCutoff)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.publicJobCutoff = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("/tonne")])])])]), _vm._v(" "), _c('div', {
    staticClass: "ibox-footer"
  }, [_c('ladda-button', {
    staticClass: "btn btn-xs btn-success",
    attrs: {
      "on-click": _vm.handleSaveSetting
    }
  }, [_vm._v("Save")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-5dc58f4e"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/system/PublicJob.vue
// module id = 1014
// module chunks = 0